import PropTypes from "prop-types"

import AuthPageContent from "./auth_page_content"
import FooterLink from "./footer_link"
import SdkLayout from "./sdk_layout"
import WorksWith from "./works_with"

import logIFTTTNextAction from "app/lib/ifttt_next_log_action"

export default function AlreadySignedInPage({
  currentUserEmail,
  nextStepColor,
  nextStepLabel,
  nextStepUrl,
  services,
}) {
  const trackSegment = () => {
    logIFTTTNextAction("click", {
      object_type: "connect_service",
      object_id: nextStepUrl,
      location_type: "web_view_applet",
    })
  }

  return (
    <SdkLayout
      footer={
        <FooterLink
          label={nextStepLabel}
          backgroundColor={nextStepColor}
          href={nextStepUrl}
          fadeIn={true}
          onClick={trackSegment}
        />
      }
    >
      <WorksWith services={services} loggedIn={true} />
      <AuthPageContent>
        <p>
          You’re signed into IFTTT as <b>{currentUserEmail}</b>.
        </p>
      </AuthPageContent>
    </SdkLayout>
  )
}

AlreadySignedInPage.propTypes = {
  currentUserEmail: PropTypes.string.isRequired,
  nextStepColor: PropTypes.string,
  nextStepLabel: PropTypes.string.isRequired,
  nextStepUrl: PropTypes.string.isRequired,
  services: WorksWith.propTypes.services,
}
